import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import statusCodes from '../shared/data/status-codes';
import commonToast from '../shared/components/NotiToast/notiToast';
import PATH from '../shared/constants/path.const';
import matchesMenuPath from '../shared/utils/menuPath';

const dynamicBaseQuery = async (args, WebApi, extraOptions) => {
  const mockUrl = extraOptions?.mock ? process.env.REACT_APP_MOCK_SERVER : undefined;
  const { pathname, search } = window.location;
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: mockUrl || process.env.REACT_APP_ROBOTEON_URL,
    timeout: 60000,
    mode: 'cors',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      const navItems = JSON.parse(localStorage.getItem('navItems'));
      const navItem = navItems?.find((item) => {
        if (window.location.pathname === '/') {
          return item.path === PATH.PRODUCT_DEVELOPMENT;
        }
        return matchesMenuPath(item.path, pathname + search);
      });
      if (sessionStorage.getItem('screen-loaded') !== pathname) {
        headers.set('Screen-Loaded', 'Y');
      }
      sessionStorage.setItem('screen-loaded', pathname);
      headers.set('Menu-Id', navItem?.menuId || '0');
      if (extraOptions && extraOptions.ignoreHeaders) {
        return headers;
      }
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      if (!headers.has('Content-Type') && !extraOptions?.ignoreContentType) {
        headers.set('Content-Type', 'application/json');
      }
      return headers;
    },
  });
  return rawBaseQuery(args, WebApi, extraOptions);
};

const baseQueryWithReauth = async (args, api, extraOptions) => {
  const { url } = args;
  const { pathname } = window.location;
  const result = await dynamicBaseQuery(args, api, extraOptions);

  if (result?.data?.result) {
    result.data.result = result?.data?.result?.toLowerCase();
    if (result.data.result === 'failure' && !extraOptions?.silentFailure) {
      commonToast(result.data?.message, 'error');
    }
  }

  if (result?.error) {
    if (result?.error?.data?.result) {
      result.error.data.result = result?.error?.data?.result?.toLowerCase();
    }
    const error = statusCodes[result.error?.status || 1008];
    commonToast(`Failed to load : ${error?.message}`, 'error');
  }

  return result;
};

const backendApi = createApi({
  reducerPath: 'backend',
  overrideExisting: true,
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});

export default backendApi;
